module.exports = __webpack_public_path__ + "static/google-play-badge-db9b21a1c41f3dcd9731e1e7acfdbb57.png";